export default __webpack_public_path__ + "static/media/logo_uni_short_res.7dc682a1.png";